module.exports = __webpack_public_path__ + "img/NNW.cc58934b.svg";